

// Blog Page
	
    
    if($("#AjaxinateLoop").length){

        function ajaxinateLoopcallBack(){
            //showNextItems(initial_items);  	
        };

        document.addEventListener("DOMContentLoaded", function() {
          var endlessScroll = new Ajaxinate({
            container: '#AjaxinateLoop',
            pagination: '#AjaxinatePagination',
            method: 'click',
            offset: 1000,
            callback: ajaxinateLoopcallBack
          });
        });
    }
    
    

if ($('.top_bar_filter_section').length){    
    
    //const ul = document.getElementById("authors");
//    const ul = document.getElementById("AjaxinateLoop");
  	const ul = $("#AjaxinateLoop");

    function createNode(element) {
        return document.createElement(element);
    }
    function append(parent, el) {
        return parent.appendChild(el);
    }
    //window.onload = fetchData("https://randomuser.me/api/?results=10");
    var get_blog_fetch_data = JSON.parse($("#blog_article_data").html());
    //window.onload = fetchData(get_blog_fetch_data);
    var datum = [];
    //alert(get_blog_fetch_data);
    //console.log(get_blog_fetch_data);
    displayData(get_blog_fetch_data);



    function displayData(authors) {
        return authors.map(function (author, index) {
            datum.push(author);

          /*
            let li = createNode("li"),
                figure = createNode("figure");
            (img = createNode("img")),
                (strong = createNode("strong")),
                (span = createNode("span"));
            address = createNode("address");
            a = createNode("a");
            addBtn = createNode("a");
            img.src = author.image.src;
            strong.innerHTML = `${author.title} ${author.handle}`;
            span.innerHTML = `${author.updated_at} ${author.body_html}`;
            a.innerHTML = `${author.body_html}`;
            a.setAttribute("href", `${author.tags}`);
            address.innerHTML = `${author.body_html}, ${author.published_at} , ${author.title}, ${author.user_id} `;
            append(figure, img);
            append(li, figure);
            append(li, strong);
            append(li, span);
            append(li, a);
            append(li, address);
            append(li, addBtn);
          */

          let li = `<article class="article grid__item small--one-whole medium--one-half large--one-third column_list" data-article-id="${author.id}">
                    <div class="mainBlog__post" data-restaurant-title="${author.title}" data-restaurant_location="${author.restaurant_location}" data-restaurant_guests="${author.restaurant_guests}" data-restaurant_space="${author.restaurant_space}">
                        <div class="blog_featured_image ${author.image.src_status}">


                            <a class="article__featured-image-link" href="/blogs/${author.handle}">
                              <noscript>
                                <img src="${author.image.src}" alt="${author.title}" />
                              </noscript>
                              <div class="article__featured-image-wrapper" style="padding-top:50.0%;">

                                <img class="article__featured-image lazyautosizes ls-is-cached lazyloaded" src="${author.image.src}">

                              </div>
                            </a>

                            <a class="article__featured-image-link article__featured-placeholder_svg-link" href="/blogs/${author.handle}">                          
								<div class="article__featured-image-wrapper" style="padding-top:50.0%;">
                             		${author.image.src_placeholder_svg}
								</div>
                            </a>

                            <div class="PrivatePartiesLogoImg ${author.restaurant_logo_status}">
                                <img src="${author.restaurant_logo}" alt="${author.title}" />
                            </div>

                            <div class="SelectForInquiryBtn">
                                <a class="btn" href="javascript:void(0)">select for inquiry 
                                  <svg class="normal_check" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="https://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8Z" stroke="white"/></svg>
                                  <svg class="selected_check" width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="https://www.w3.org/2000/svg"><circle cx="7" cy="7" r="7" fill="#DA5726"/><path d="M9.72727 5L6.53636 9.5L4 6.84091" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                </a>
                            </div>


                        </div>

                        <div class="mainBlog__content">
                            <div class="grid-uniform">
                                <div class="grid__item small--one-half large--one-half">
                                    <div class="PrivatePartiesLocation">
                                        <h5>location</h5>
                                        <h7 class="title_h7">${author.restaurant_location}</h7>
                                    </div>
                                </div>

                                <div class="grid__item small--one-half large--one-half">
                                    <div class="PrivatePartiesCuisine">
                                        <h5>cuisine</h5>
                                        <h7 class="title_h7">${author.restaurant_cuisine}</h7>
                                    </div>

                                </div>


                                <div class="grid__item small--one-half large--one-half">
                                    <div class="PrivatePartiesBottomBlock">
                                        <div class="d-flex d-align-item">
                                            <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="https://www.w3.org/2000/svg">
                                      <path d="M15.7035 3.5625C15.5891 5.15117 14.4106 6.375 13.1254 6.375C11.8403 6.375 10.6598 5.15156 10.5473 3.5625C10.4301 1.90977 11.5774 0.75 13.1254 0.75C14.6735 0.75 15.8207 1.93984 15.7035 3.5625Z" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      <path d="M13.1248 8.875C10.5791 8.875 8.1311 10.1395 7.51781 12.602C7.43656 12.9277 7.64086 13.25 7.97563 13.25H18.2745C18.6092 13.25 18.8123 12.9277 18.7323 12.602C18.119 10.1 15.6709 8.875 13.1248 8.875Z" stroke="#CFC8BD" stroke-width="1.5" stroke-miterlimit="10"></path>
                                      <path d="M7.81214 4.26328C7.72073 5.53203 6.76839 6.53125 5.74183 6.53125C4.71526 6.53125 3.76136 5.53242 3.67152 4.26328C3.57816 2.94336 4.50511 2 5.74183 2C6.97854 2 7.9055 2.96758 7.81214 4.26328Z" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      <path d="M8.04725 8.95313C7.34218 8.63008 6.56561 8.50586 5.74257 8.50586C3.71132 8.50586 1.75429 9.51562 1.26405 11.4824C1.1996 11.7426 1.36288 12 1.63007 12H6.016" stroke="#CFC8BD" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"></path>
                                    </svg>
                                            <h7 class="title_h7">${author.restaurant_guests}</h7>
                                        </div>
                                        <div class="d-flex d-align-item">
                                            <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="https://www.w3.org/2000/svg">
                                      <path d="M1.87501 11.125L18.125 11.125C18.4702 11.125 18.75 10.8452 18.75 10.5V1.75C18.75 1.40482 18.4702 1.125 18.125 1.125L1.87501 1.125C1.52983 1.125 1.25001 1.40482 1.25001 1.75V10.5C1.25001 10.8452 1.52983 11.125 1.87501 11.125Z" stroke="#CFC8BD" stroke-width="1.5" stroke-linejoin="round"></path>
                                      <path d="M2.5 13H17.5" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      <path d="M3.75 14.875H16.25" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      <path d="M10 9.25097C11.7259 9.25097 13.125 7.85186 13.125 6.12597C13.125 4.40009 11.7259 3.00098 10 3.00098C8.27411 3.00098 6.875 4.40009 6.875 6.12597C6.875 7.85186 8.27411 9.25097 10 9.25097Z" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      <path d="M18.75 4.25C17.9212 4.25 17.1263 3.92076 16.5403 3.33471C15.9542 2.74866 15.625 1.9538 15.625 1.125" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      <path d="M1.25 4.25C1.66038 4.25 2.06674 4.16917 2.44589 4.01212C2.82503 3.85508 3.16953 3.62489 3.45971 3.33471C3.74989 3.04452 3.98008 2.70003 4.13712 2.32089C4.29417 1.94174 4.375 1.53538 4.375 1.125" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      <path d="M18.75 8C17.9212 8 17.1263 8.32924 16.5403 8.91529C15.9542 9.50134 15.625 10.2962 15.625 11.125" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      <path d="M1.25 8C1.66038 8 2.06674 8.08083 2.44589 8.23788C2.82503 8.39492 3.16953 8.62511 3.45971 8.91529C3.74989 9.20547 3.98008 9.54997 4.13712 9.92911C4.29417 10.3083 4.375 10.7146 4.375 11.125" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                            <h7 class="ProPrice title_h7">${author.restaurant_price}</h7>
                                        </div>
                                    </div>
                                </div>

                                <div class="grid__item small--one-half large--one-half">
                                    <div class="PrivatePartiesButton">
                                        <a class="btn" href="/blogs/${author.handle}">see details</a>
                                    </div>
                                </div>

                            </div>



                        </div>
                    </div>
                </article>`;             

            //$(ul).append(li);
            //append(ul, li);
			$("#AjaxinateLoop").append(li);
            
            $(".blogArticle_column article.article").slice(0, 6).show();         

        });
    }
  
  

    function prepareList(author) {
        var results = "";
      /*
        results = `<li><figure><img src=${author.image.src} /></figure>\n
                    <strong>${author.title} ${author.handle}</strong>\n
                    <span>${author.updated_at}</span>\n
                    <span>${author.body_html}</span>\n
                    <a href= ${author.tags}>${author.title}</a>\n
                    <address>${author.body_html}, ${author.published_at}, ${author.title}, ${author.user_id} </address>\n
                    \n
                    </li>`;
    */                
      /*
        results = `<li><figure><img src=${author.image.src} /></figure>\n
                    <strong>${author.title} ${author.handle}</strong>\n
                    <span>${author.updated_at}</span>\n
                    <span>${author.body_html}</span>\n
                    <a href= ${author.tags}>${author.title}</a>\n
                    <address>${author.body_html}, ${author.published_at}, ${author.title}, ${author.user_id} </address>\n
                    \n
                    </li>`;  
      */

            //results = `<article class="article grid__item small--one-whole medium--one-half large--one-third column_list" data-article-id="${author.id}" style="display: block;">
           results = `<article class="article grid__item small--one-whole medium--one-half large--one-third column_list" data-article-id="${author.id}">
                    <div class="mainBlog__post" data-restaurant-title="${author.title}" data-restaurant_location="${author.restaurant_location}" data-restaurant_guests="${author.restaurant_guests}" data-restaurant_space="${author.restaurant_space}">
                        <div class="blog_featured_image ${author.image.src_status}">


                            <a class="article__featured-image-link" href="/blogs/${author.handle}">
                              <noscript>
                                <img src="${author.image.src}" alt="${author.title}" />
                              </noscript>
                              <div class="article__featured-image-wrapper" style="padding-top:50.0%;">

                                <img class="article__featured-image lazyautosizes ls-is-cached lazyloaded" src="${author.image.src}">

                              </div>
                            </a>

                            <a class="article__featured-image-link article__featured-placeholder_svg-link" href="/blogs/${author.handle}">                          
								<div class="article__featured-image-wrapper" style="padding-top:50.0%;">
                             		${author.image.src_placeholder_svg}
								</div>
                            </a>

                            <div class="PrivatePartiesLogoImg ${author.restaurant_logo_status}">
                                <img src="${author.restaurant_logo}" alt="${author.title}" />
                            </div>

                            <div class="SelectForInquiryBtn">
                                <a class="btn" href="javascript:void(0)">select for inquiry 
                                  <svg class="normal_check" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="https://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8Z" stroke="white"/></svg>
                                  <svg class="selected_check" width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="https://www.w3.org/2000/svg"><circle cx="7" cy="7" r="7" fill="#DA5726"/><path d="M9.72727 5L6.53636 9.5L4 6.84091" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                </a>
                            </div>


                        </div>

                        <div class="mainBlog__content">
                            <div class="grid-uniform">
                                <div class="grid__item small--one-half large--one-half">
                                    <div class="PrivatePartiesLocation">
                                        <h5>location</h5>
                                        <h7 class="title_h7">${author.restaurant_location}</h7>
                                    </div>
                                </div>

                                <div class="grid__item small--one-half large--one-half">
                                    <div class="PrivatePartiesCuisine">
                                        <h5>cuisine</h5>
                                        <h7 class="title_h7">${author.restaurant_cuisine}</h7>
                                    </div>

                                </div>


                                <div class="grid__item small--one-half large--one-half">
                                    <div class="PrivatePartiesBottomBlock">
                                        <div class="d-flex d-align-item">
                                            <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="https://www.w3.org/2000/svg">
                                      <path d="M15.7035 3.5625C15.5891 5.15117 14.4106 6.375 13.1254 6.375C11.8403 6.375 10.6598 5.15156 10.5473 3.5625C10.4301 1.90977 11.5774 0.75 13.1254 0.75C14.6735 0.75 15.8207 1.93984 15.7035 3.5625Z" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      <path d="M13.1248 8.875C10.5791 8.875 8.1311 10.1395 7.51781 12.602C7.43656 12.9277 7.64086 13.25 7.97563 13.25H18.2745C18.6092 13.25 18.8123 12.9277 18.7323 12.602C18.119 10.1 15.6709 8.875 13.1248 8.875Z" stroke="#CFC8BD" stroke-width="1.5" stroke-miterlimit="10"></path>
                                      <path d="M7.81214 4.26328C7.72073 5.53203 6.76839 6.53125 5.74183 6.53125C4.71526 6.53125 3.76136 5.53242 3.67152 4.26328C3.57816 2.94336 4.50511 2 5.74183 2C6.97854 2 7.9055 2.96758 7.81214 4.26328Z" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      <path d="M8.04725 8.95313C7.34218 8.63008 6.56561 8.50586 5.74257 8.50586C3.71132 8.50586 1.75429 9.51562 1.26405 11.4824C1.1996 11.7426 1.36288 12 1.63007 12H6.016" stroke="#CFC8BD" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"></path>
                                    </svg>
                                            <h7 class="title_h7">${author.restaurant_guests}</h7>
                                        </div>
                                        <div class="d-flex d-align-item">
                                            <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="https://www.w3.org/2000/svg">
                                      <path d="M1.87501 11.125L18.125 11.125C18.4702 11.125 18.75 10.8452 18.75 10.5V1.75C18.75 1.40482 18.4702 1.125 18.125 1.125L1.87501 1.125C1.52983 1.125 1.25001 1.40482 1.25001 1.75V10.5C1.25001 10.8452 1.52983 11.125 1.87501 11.125Z" stroke="#CFC8BD" stroke-width="1.5" stroke-linejoin="round"></path>
                                      <path d="M2.5 13H17.5" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      <path d="M3.75 14.875H16.25" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      <path d="M10 9.25097C11.7259 9.25097 13.125 7.85186 13.125 6.12597C13.125 4.40009 11.7259 3.00098 10 3.00098C8.27411 3.00098 6.875 4.40009 6.875 6.12597C6.875 7.85186 8.27411 9.25097 10 9.25097Z" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      <path d="M18.75 4.25C17.9212 4.25 17.1263 3.92076 16.5403 3.33471C15.9542 2.74866 15.625 1.9538 15.625 1.125" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      <path d="M1.25 4.25C1.66038 4.25 2.06674 4.16917 2.44589 4.01212C2.82503 3.85508 3.16953 3.62489 3.45971 3.33471C3.74989 3.04452 3.98008 2.70003 4.13712 2.32089C4.29417 1.94174 4.375 1.53538 4.375 1.125" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      <path d="M18.75 8C17.9212 8 17.1263 8.32924 16.5403 8.91529C15.9542 9.50134 15.625 10.2962 15.625 11.125" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      <path d="M1.25 8C1.66038 8 2.06674 8.08083 2.44589 8.23788C2.82503 8.39492 3.16953 8.62511 3.45971 8.91529C3.74989 9.20547 3.98008 9.54997 4.13712 9.92911C4.29417 10.3083 4.375 10.7146 4.375 11.125" stroke="#CFC8BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                            <h7 class="ProPrice title_h7">${author.restaurant_price}</h7>
                                        </div>
                                    </div>
                                </div>

                                <div class="grid__item small--one-half large--one-half">
                                    <div class="PrivatePartiesButton">
                                        <a class="btn" href="/blogs/${author.handle}">see details</a>
                                    </div>
                                </div>

                            </div>



                        </div>
                    </div>
                </article>`;   

        return results;
    }

    /*-----------filter----------*/
    function filter() { 
        //const ul = document.getElementById("AjaxinateLoop");
      const ul = $("#AjaxinateLoop");
        var a = document.getElementById("select");
        var b = a.options[a.selectedIndex].value;
        var items = document.getElementsByName("acs");
        var selectedItems = [];
        for (var i = 0; i < items.length; i++) {
            if (items[i].type == "checkbox" && items[i].checked == true) {
                selectedItems.push(items[i].value);
            }
        }
        var showresults = prepareFilterData(datum, b, selectedItems);
        console.log(showresults);
        showresults ? counterResults(showresults) : null;
    }
  
    function filter_restaurant() { 
        //const ul = document.getElementById("AjaxinateLoop");
      const ul = $("#AjaxinateLoop");
        var items = document.getElementsByName("restaurant_check");
        var selectedItems = [];
        for (var i = 0; i < items.length; i++) {
            if (items[i].type == "checkbox" && items[i].checked == true) {
                selectedItems.push(items[i].value);
              	//selectedItems.push(items[i].attr("data-filter-opt"));
            }
        }
        if(selectedItems.length == 0){
			$("body .outer_search_box").addClass("error_active_box");
        }else{
          	$("body .outer_search_box").removeClass("error_active_box");
            $(".demo-modal .modal-close-btn").trigger("click");
        }
        var showresults = prepareRestaurantFilterData(datum, selectedItems);
        console.log(showresults);
        showresults ? counterResults(showresults) : null;      
    }  
  
    function filter_restaurant_cuisine() { 
        //const ul = document.getElementById("AjaxinateLoop");
      const ul = $("#AjaxinateLoop");
        var items = document.getElementsByName("restaurant_cuisine_check");
        var selectedItems = [];
        for (var i = 0; i < items.length; i++) {
            if (items[i].type == "checkbox" && items[i].checked == true) {
                selectedItems.push(items[i].value);
              	//selectedItems.push(items[i].attr("data-filter-opt"));
            }
        }
      
        if(selectedItems.length == 0){
			$("body .outer_search_box").addClass("error_active_box");
        }else{
          	$("body .outer_search_box").removeClass("error_active_box");
          	$(".demo-modal .modal-close-btn").trigger("click");
        }
      
        var showresults = prepareCuisineFilterData(datum, selectedItems);
        console.log(showresults);
        showresults ? counterResults(showresults) : null;
    }  
  
    function filter_restaurant_space() { 
        //const ul = document.getElementById("AjaxinateLoop");
      const ul = $("#AjaxinateLoop");
        var items = document.getElementsByName("restaurant_space_check");
        var selectedItems = [];
        for (var i = 0; i < items.length; i++) {
            if (items[i].type == "checkbox" && items[i].checked == true) {
                selectedItems.push(items[i].value);
              	//selectedItems.push(items[i].attr("data-filter-opt"));
            }
        }
      
        if(selectedItems.length == 0){
			$("body .outer_search_box").addClass("error_active_box");
        }else{
          	$("body .outer_search_box").removeClass("error_active_box");
          	$(".demo-modal .modal-close-btn").trigger("click");
        }
      
        var showresults = prepareSpaceFilterData(datum, selectedItems);
        console.log(showresults);
        showresults ? counterResults(showresults) : null;
    }    

    function counterResults(showresults) {
        if (showresults["count"] > 0) {
            //ul.innerHTML = showresults["results"];                    
          	$("#AjaxinateLoop").html(showresults["results"]);
          
            $(".blogArticle_column article.article").slice(0, 6).show();         
          
          	if (showresults["count"] > 6) {              
          		$(".AjaxinatePagination-block .load-more").removeAttr("style");              
            }else{
              $(".AjaxinatePagination-block .load-more").css("visibility","hidden");              
            }          
          
          
        } else {
            //ul.innerHTML = "No results found";
          	$("#AjaxinateLoop").html('<div class="empty_box_msg">No results found</div>');
            $(".AjaxinatePagination-block .load-more").css("visibility","hidden"); 
        }
    }

    function prepareFilterData(datum, b, selectedItems) {
        var results = "";
        var count = 0;
        datum.map(function (author) {
            if (b === author.gender) {
                if (selectedItems.length == 0) {
                    count++;
                    results += prepareList(author);
                } else {
                    for (var i = 0; i < selectedItems.length; i++) {
                        if (author.location.country === selectedItems[i]) {
                            count++;
                            console.log(author.location.country, author.name, i);
                            results += prepareList(author);
                        }
                    }
                }
            } else if (b === "all") {
                console.log(b);
                if (selectedItems.length == 0) {
                    count++;
                    results += prepareList(author);
                }
                for (var i = 0; i < selectedItems.length; i++) {
                    if (author.location.country === selectedItems[i]) {
                        count++;
                        results += prepareList(author);
                    }
                }
                console.log(results);
            }
        });

        return { count: count, results: results };
    }

    function prepareRestaurantFilterData(datum, selectedItems) {
        var results = "";
        var count = 0;
        datum.map(function (author) {

                if (selectedItems.length == 0) {
                    count++;
                    results += prepareList(author);
                } else {
                    for (var i = 0; i < selectedItems.length; i++) {
                        if (author.restaurant === selectedItems[i]) {
                            count++;
                            console.log(author.restaurant, author.handle, i);
                            results += prepareList(author);
                        }
                    }
                }
        });

        return { count: count, results: results };
    }
  
    function prepareCuisineFilterData(datum, selectedItems) {
        var results = "";
        var count = 0;
        datum.map(function (author) {

                if (selectedItems.length == 0) {
                    count++;
                    results += prepareList(author);
                } else {
                    for (var i = 0; i < selectedItems.length; i++) {
                        //if (author.restaurant_cuisine === selectedItems[i]) {
                      	if(author.restaurant_cuisine.indexOf(selectedItems[i]) != -1){
                            count++;
                            console.log(author.restaurant_cuisine, author.handle, i);
                            results += prepareList(author);
                        }
                    }
                }
        });

        return { count: count, results: results };
    } 
  
    function prepareSpaceFilterData(datum, selectedItems) {
        var results = "";
        var count = 0;
        datum.map(function (author) {

                if (selectedItems.length == 0) {
                    count++;
                    results += prepareList(author);
                } else {
                    for (var i = 0; i < selectedItems.length; i++) {
                        //if (author.restaurant_space === selectedItems[i]) {
                      	if(author.restaurant_space.indexOf(selectedItems[i]) != -1){
                            count++;
                            console.log(author.restaurant_space, author.handle, i);
                            results += prepareList(author);
                        }
                    }
                }
        });

        return { count: count, results: results };
    }   
  
    /*-------searching-------*/
    function showResults() {
        //const ul = document.getElementById("AjaxinateLoop");
      	const ul = $("#AjaxinateLoop");
        var showresults = search(authors);
        console.log(showresults);
        showresults ? counterResults(showresults) : null;
    }

    function search() {
        var results = "";
        var count = 0;
        //var searchText = document.getElementById("search-box").value;
        //var searchTextRestaurant = document.getElementById("restaurant_search-box").value;  
        var searchTextZipCode = document.getElementById("zip_code_search-box").value;
        //var searchTextCuisine = document.getElementById("cuisine_search-box").value;
        //var searchTextSpace = document.getElementById("space_search-box").value;
        var searchTextGuest = document.getElementById("guests_search-box").value;   

        searchTextZipCode = searchTextZipCode.toLowerCase();

        console.log(searchTextZipCode, datum);

        var get_selected_filter_type = $("body").attr("data-filter-type-selected");


        var find_item_status = "";

      /*
        if(get_selected_filter_type == "restaurant"){
            if(searchTextRestaurant.length < 2){
              $(".restaurant_search_box").find(".msg_panel").text("Error: Enter The Restaurant Name");
              $(".restaurant_search_box").addClass("active_error_block");
              find_item_status = "";
            }else{
              $(".restaurant_search_box").find(".msg_panel").text("");
              $(".restaurant_search_box").addClass("active_error_block");

              find_item_status = "true";
              $(".demo-modal .modal-close-btn").trigger("click");
              $(".top_bar_filter_selected_option_section .f_search_restaurant").text(searchTextRestaurant);
              $(".top_bar_filter_selected_option_section .f_search_restaurant").text(searchTextRestaurant);
              $(".top_bar_filter_selected_option_section").find("[data-filter-type='restaurant']").addClass("active");
            }
        }
	*/
      
        if(get_selected_filter_type == "location"){
            if(searchTextZipCode.length < 4){
              $(".location_zip_search_box").find(".msg_panel").text("Error: Enter the zip code");
              $(".location_zip_search_box").addClass("active_error_block");
              find_item_status = "";
            }else{
              $(".location_zip_search_box").find(".msg_panel").text("");
              $(".location_zip_search_box").addClass("active_error_block");
              find_item_status = "true";
              $(".demo-modal .modal-close-btn").trigger("click");
              $(".top_bar_filter_selected_option_section .f_search_location").text(searchTextZipCode);
              $(".top_bar_filter_selected_option_section").find("[data-filter-type='location']").addClass("active");
            }
        }

      /*
        if(get_selected_filter_type == "cuisine"){
            if(searchTextCuisine.length < 2){
              $(".cuisine_search_box").find(".msg_panel").text("Error: Enter cuisine");
              $(".cuisine_search_box").addClass("active_error_block");
              find_item_status = "";
            }else{
              $(".cuisine_search_box").find(".msg_panel").text("");
              $(".cuisine_search_box").addClass("active_error_block");
              find_item_status = "true";
              $(".demo-modal .modal-close-btn").trigger("click");
              $(".top_bar_filter_selected_option_section .f_search_cuisine").text(searchTextCuisine);
              $(".top_bar_filter_selected_option_section").find("[data-filter-type='cuisine']").addClass("active");
            }
        }

        if(get_selected_filter_type == "space"){
            if(searchTextSpace.length == 0){
              $(".space_search_box").find(".msg_panel").text("Error: Enter the space");
              $(".space_search_box").addClass("active_error_block");
              find_item_status = "";
            }else{
              $(".space_search_box").find(".msg_panel").text("");
              $(".space_search_box").removeClass("active_error_block");
              find_item_status = "true";
              $(".demo-modal .modal-close-btn").trigger("click");
              $(".top_bar_filter_selected_option_section .f_search_space").text(searchTextSpace);
              $(".top_bar_filter_selected_option_section").find("[data-filter-type='space']").addClass("active");
            }
        }  
        */

        if(get_selected_filter_type == "guests"){
            if(searchTextGuest.length == 0){
              $(".guests_search_box").find(".msg_panel").text("Error: Enter the number guests");
              $(".guests_search_box").addClass("active_error_block");
              find_item_status = "";
            }else{
              $(".guests_search_box").find(".msg_panel").text("");
              $(".guests_search_box").removeClass("active_error_block");
              find_item_status = "true";
              $(".demo-modal .modal-close-btn").trigger("click");
              $(".top_bar_filter_selected_option_section .f_search_guests").text(searchTextGuest);
              $(".top_bar_filter_selected_option_section").find("[data-filter-type='guests']").addClass("active");
            }
        }    

        if(find_item_status == "true"){

            datum.map(function (author) {
                var text = author.restaurant_location_zip_code;
                text = author.restaurant_location_zip_code.toLowerCase();

                var text_restaurant = author.title.toLowerCase();
                var text_zip_code = author.restaurant_location_zip_code.toLowerCase();
                var text_cuisine = author.restaurant_cuisine.toLowerCase();
                var text_space = author.restaurant_space.toLowerCase();
                var text_guests = author.restaurant_guests.toLowerCase();

              //alert(text);
                var slicedText = text_zip_code.slice(0, searchTextZipCode.length);

                //if(((text_zip_code.indexOf(searchTextZipCode) != -1) && (searchTextZipCode != "")) || ((text_restaurant.indexOf(searchTextRestaurant) != -1) && (searchTextRestaurant != "")) || ((text_cuisine.indexOf(searchTextCuisine) != -1) && (searchTextCuisine != "")) || ((text_space.indexOf(searchTextSpace) != -1) && (searchTextSpace != "")) || ((text_guests.indexOf(searchTextGuest) != -1) && (searchTextGuest != ""))){          	
                if(((text_zip_code.indexOf(searchTextZipCode) != -1) && (searchTextZipCode != "")) || ((text_guests.indexOf(searchTextGuest) != -1) && (searchTextGuest != ""))){          	
                    count++;
                    results += prepareList(author);            
                    //alert(count);
                }            	  
            });

            console.log(results, count);

            if(count > 0){
              $(".top_bar_filter_selected_option_section").addClass("active_search_selected_opt");
            }else{
              $(".top_bar_filter_selected_option_section").removeClass("active_search_selected_opt");
            }

            return { count: count, results: results };      
        }
    }

    function showResultsAll() {
        //const ul = document.getElementById("AjaxinateLoop");
      	const ul = $("#AjaxinateLoop");
        var showresults = searchAll(authors);
        console.log(showresults);
        showresults ? counterResults(showresults) : null;
    }

    function searchAll() {
        var results = "";
        var count = 0; 
        var searchTextZipCode = "";


        searchTextZipCode = searchTextZipCode.toLowerCase();

        console.log(searchTextZipCode, datum);


        datum.map(function (author) {
            var text = author.restaurant_location_zip_code;
            text = author.restaurant_location_zip_code.toLowerCase();

            var text_zip_code = author.restaurant_location_zip_code.toLowerCase();


          //alert(text);
            var slicedText = text_zip_code.slice(0, searchTextZipCode.length);


            if(text_zip_code.indexOf(searchTextZipCode) != -1){
                count++;
                results += prepareList(author);            
            }      

        });

        console.log(results, count);   

        $(".top_bar_filter_selected_option_section .f_search_restaurant").text("");
        $(".top_bar_filter_selected_option_section .f_search_location").text("");
        $(".top_bar_filter_selected_option_section .f_search_cuisine").text("");
        $(".top_bar_filter_selected_option_section .f_search_space").text("");
        $(".top_bar_filter_selected_option_section .f_search_guests").text("");  
        $(".top_bar_filter_selected_option_section").removeClass("active_search_selected_opt");
        $(".top_bar_filter_selected_option_section .filter_item").removeClass("active");
        return { count: count, results: results };    
    }
  
} 


$("body").on('click touchstart', '.load-more', function (e) {
			e.preventDefault();
			$(".blogArticle_column article.article:hidden").slice(0, 3).slideDown();
			if ($(".blogArticle_column article.article:hidden").length == 0) {
				$(".load-more").css('visibility', 'hidden');
			}
  /*
			$('html,body').animate({
				scrollTop: $(this).offset().top
			}, 1000);
            */
});

// Filter Popup//

/*
(function($) {
    'use strict';
    
    var $document = $(document);
    var $body  = $('body');
    var $roots = $('html').add($body);
    var cache  = {};

    $.modal = function(settings) {

        function Modal() {
            var modal = this;
            var modalCreated = false;
            modal.isActive = false;

            var config = $.extend({
                content: '', // content to show initial
                contentUrl: null, // content from an external url (ajax-loaded)
                useCache: true, // don't repeat ajax-load every time
                youtubeId: null, // show youtube-iframe
                class: '', // custom class for modal
                closeBtn: true, // show x-close-btn
                layerClose: true, // modal closes when layer is clicked
                closingSelectors: null, // custom selectors for elements to close modal
                showOnInit: true, // show modal when created
                fadeInDuration: 400, // how fast modal fades in
                fadeOutDuration: 400, // how fast modal fades out
                beforeModalOpen: null, // callback before modal appears - returns modal
                afterModalOpen: null, // callback after modal appears - returns modal
                beforeModalClose: null, // callback before modal disappears - returns modal
                afterModalClose: null // callback after modal disappears - returns modal
            }, settings);

            var init = function() {
                //if (config.showOnInit) modal.open();
                if (config.showOnInit);
            };

            var createModal = function() {
                var closingX = '<svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 96 96" width="12" height="12"><polygon fill="currentColor" points="96,14 82,0 48,34 14,0 0,14 34,48 0,82 14,96 48,62 82,96 96,82 62,48 "/></svg>';
                
                var modalClass = 'modal ' + config.class;
                if (config.youtubeId) {
                    modalClass = modalClass + ' modal-youtube';
                }

                modal.$wrapper = $('<div>', {
                    class: 'modal-wrapper'
                });

                modal.$layer = $('<div>', {
                    class: 'modal-layer'
                });

                modal.$modal = $('<div>', {
                    class: modalClass
                });

                if (config.closeBtn) {
                    modal.$closeBtn = $('<button>', {
                        class: 'modal-close-btn' 
                    }).html(closingX);

                    modal.$modal.append(modal.$closeBtn);
                }

                modal.$content = $('<div>', {
                    class: 'modal-content'
                }).html(config.content);

                modal.$modal.append(modal.$content);
                modal.$wrapper.append(modal.$layer);
                modal.$wrapper.append(modal.$modal);

                modal.$wrapper.hide();

                if (config.contentUrl) loadExternal();
                if (config.youtubeId) loadYoutubeVideo();
                modalCreated = true;
            };

            modal.updateContent = function(content) {
                modal.$content.html(content);
            };

            modal.open = function() {
                if (!modalCreated) createModal();

                if (typeof config.beforeModalOpen === 'function') config.beforeModalOpen(modal);
                appendToBody();
                enableRootsActive();
                modal.$wrapper.fadeIn(config.fadeInDuration ,function() {
                    modal.isActive = true;
                    if (typeof config.afterModalOpen === 'function') config.afterModalOpen(modal);
                });
            };

            modal.close = function() {
                if (typeof config.beforeModalClose === 'function') config.beforeModalClose(modal);
                modal.$wrapper.fadeOut(config.fadeOutDuration, function() {
                    removeFromBody();
                    disableRootsActive();
                    modal.isActive = false;
                    if (typeof config.afterModalClose === 'function') config.afterModalClose(modal);
                });
            };

            var bindClose = function() {
                if (config.closeBtn) modal.$closeBtn.click(modal.close);
                if (config.layerClose) modal.$layer.click(modal.close);
                if (config.closingSelectors) modal.$modal.on('click', config.closingSelectors.toString(), modal.close);
            };

            var offset = 0;

            var enableRootsActive = function() {
                offset = $document.scrollTop();
                $roots.css('top', (-offset) + 'px')
                      .addClass('modal-active');
            };

            var disableRootsActive = function() {
                $roots.css('top', '')
                      .removeClass('modal-active')
                      .scrollTop(offset);
            };

            var appendToBody = function() {
                $body.append(modal.$wrapper);
                bindClose();
            };

            var removeFromBody = function() {
                modal.$wrapper.remove();
            };

            var loadYoutubeVideo = function() {
                var $iframe = $('<iframe>', {
                    css: {
                        width: '100%',
                        height: '100%',
                        display: 'block'
                    },
                    src: 'https://www.youtube.com/embed/' + config.youtubeId,
                    frameborder: 0,
                    allowfullscreen: 'allowfullscreen'
                });

                modal.updateContent($iframe);
            };

            var loadExternal = function() {
                if (config.useCache && cache[config.contentUrl]) {
                    var cachedContent = cache[config.contentUrl];
                    modal.updateContent(cachedContent);
                } else {
                    $.get(config.contentUrl, function(response) {
                        var ajaxContent = response;
                        modal.updateContent(ajaxContent);
                        cache[config.contentUrl] = ajaxContent;
                    }).fail(function() {
                        console.log('Ajax failed - wrong URL?');
                    });
                }
            };

            init();

            return modal;
        }

        return new Modal();
    };

})(jQuery);

var demoModal = $.modal({
	 content: $('#demo-modal-content'),
    class: 'demo-modal',
    //useCache: false,
	 closingSelectors: ['.modal-close']
});
*/


$('#fadePopup').click(function() {
    //demoModal.open();
  	$("body,html").addClass("modal-active");
  	$(".modal-wrapper-outer").removeClass("hide");
});
    


$(document).ready(function() {
    
  var $document = $(document);            
  var $body  = $('body');
  var $roots = $('html').add($body);  
  var offset = 0;  
  

  
  
  
  $("body").attr("data-filter-type-selected","");
  $('body').on('click', '.top_bar_filter_inner_section .filter_item', function() {
    	var get_filter_type = $(this).attr("data-filter-type");
    	var get_filter_panel = $(this).attr("data-filter-panel");
    //alert(get_filter_panel);
    
        if(get_filter_type !== undefined){
            //alert(get_filter_type);
          if(get_filter_type == "all"){
            
            //Clear All the checkboxes
            $('body').find('.inner_check_box_section .outer_search_box .form-checkbox-group input').each(function() {
              console.log("input found");
              $(this).removeAttr('checked');
              $(this).prop('checked', false);
                if($(this).is(":checked")){
                  	alert("checked");
                }
              //$(this).trigger("change");
            });            
            
            
        var blog_newurl_clear = window.location.protocol + '//' + window.location.host + window.location.pathname;
        window.history.replaceState({path: blog_newurl_clear},'',blog_newurl_clear);             
            
            	showResultsAll();

              //$(".inner_search_box #restaurant_search-box").val("");  
              $(".inner_search_box #zip_code_search-box").val("");  
              //$(".inner_search_box #cuisine_search-box").val("");  
              //$(".inner_search_box #space_search-box").val("");  
              $(".inner_search_box #guests_search-box").val("");                                     
            
          }else{
            
            if(get_filter_panel == "checkbox"){
              	$("body").addClass("filter_checkbox_popup_panel");
            }else{
                $("body").removeClass("filter_checkbox_popup_panel");
            }
            
            //demoModal.open();            
            


            //var enableRootsActive = function() {
                offset = $document.scrollTop();
                $roots.css('top', (-offset) + 'px')
                      .addClass('modal-active');
            //};
        
            
            //$("body,html").addClass("modal-active");
            $(".modal-wrapper-outer").removeClass("hide");            
            
            $("body").attr("data-filter-type-selected",get_filter_type);          	
          }
        }
  });
  
  $('body').on('click', '.modal-wrapper-outer .modal-close-btn', function() {
    //demoModal.open();
      //$("body,html").removeClass("modal-active");
    
    //var disableRootsActive = function() {
      $roots.css('top', '')
      .removeClass('modal-active')
      .scrollTop(offset);
    //};        
    
      $(".modal-wrapper-outer").addClass("hide");
    
  });    
  
  
  $('body').on('click', '.SelectForInquiryBtn .btn', function() {
      if($(this).closest(".SelectForInquiryBtn").hasClass("selected_item")){
        	$(this).closest(".SelectForInquiryBtn").removeClass("selected_item");
      }else{
        	$(this).closest(".SelectForInquiryBtn").addClass("selected_item");
      }
    
    
    
      var get_selected_item_counter_outer = 0;
      
	  var get_selected_item_variant_outer = "";
    
      $(".selected_locations_section .outer_selected_locations_block .selected_body_block .selected_body_location_list").text("");
      
      $(".blogArticle_column article.article").each(function(){      
          //alert($(this).text());
          if($(this).find(".SelectForInquiryBtn").hasClass("selected_item")){
            
            var get_article_id = $(this).closest(".article").attr("data-article-id");
            
            get_selected_item_counter_outer = get_selected_item_counter_outer + 1; 
            
            var get_article_restaurant_title = $(this).closest(".article").find(".mainBlog__post").attr("data-restaurant-title");
            var get_article_restaurant_location = $(this).closest(".article").find(".mainBlog__post").attr("data-restaurant_location");
            var get_article_restaurant_guests = $(this).closest(".article").find(".mainBlog__post").attr("data-restaurant_guests");
            var get_article_restaurant_space = $(this).closest(".article").find(".mainBlog__post").attr("data-restaurant_space");
            
            var selected_location_item = `<div class="location_item" data-article-id="${get_article_id}">
                <div class="PrivateParties_info">
                    <h3>${get_article_restaurant_title}</h3>
                    <div class="title_info">${get_article_restaurant_location} ${get_article_restaurant_space} space | $$ | group ${get_article_restaurant_guests}</div>
                </div>
                <span class="remove_btn">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="https://www.w3.org/2000/svg"><g opacity="0.4"><path d="M10.4451 10.4444L1.55626 1.55556" stroke="white" stroke-width="2" stroke-linecap="round"/><path d="M10.4442 1.55556L1.55534 10.4444" stroke="white" stroke-width="2" stroke-linecap="round"/></g></svg>                        
                </span>  
            </div>`;
    
            $(".selected_locations_section .outer_selected_locations_block .selected_body_block .selected_body_location_list").append(selected_location_item);
            
          }
      });     
    
      //alert(get_selected_item_counter_outer);
    	$(".selected_locations_section .outer_selected_locations_block .selected_header_block .selected_location_counter").html("("+get_selected_item_counter_outer+")");
      if(get_selected_item_counter_outer > 0 ){
        	$(".selected_locations_section").addClass("panel_visible");
      }else{
        	$(".selected_locations_section").removeClass("panel_visible");
      }
  });  
  
  
  $('body').on('click', '.selected_locations_section .outer_selected_locations_block .selected_header_block', function() {
      if($(this).closest(".selected_locations_section").hasClass("location_panel_active")){
        	//$(this).closest(".SelectForInquiryBtn").removeClass("location_panel_active");
        	
      }else{
        	$(this).closest(".selected_locations_section").addClass("location_panel_active");
       		$(this).closest(".selected_locations_section").find(".selected_body_block").slideDown();
        	
        	$("body").addClass("open_selected_location_panel");
      }
  });  
  
  
  $('body').on('click', '.selected_locations_section .outer_selected_locations_block .selected_header_block .selected_location_close_btn', function() {
        	//$(this).closest(".selected_locations_section").removeClass("location_panel_active");
       		$(this).closest(".selected_locations_section").find(".selected_body_block").slideUp();      
    		setTimeout(function(){ 
              $(".selected_locations_section").removeClass("location_panel_active")
              $("body").removeClass("open_selected_location_panel");
            }, 500);
  });  
  
  $('body').on('click', '.selected_locations_section .outer_selected_locations_block .location_item .remove_btn', function() {
        	//$(this).closest(".selected_locations_section").removeClass("location_panel_active");
       		var get_remove_item_id = $(this).closest(".location_item").attr("data-article-id");      
    		$(".blogArticle_column").find("[data-article-id='" + get_remove_item_id + "'] .SelectForInquiryBtn").removeClass("selected_item"); 
    		$(this).closest(".location_item").fadeOut();
    		$(this).closest(".location_item").remove();
    
      var get_selected_item_counter_outer = 0;
      
      
      $(".blogArticle_column article.article").each(function(){
          //alert($(this).text());
          if($(this).find(".SelectForInquiryBtn").hasClass("selected_item")){
            
            var get_article_id = $(this).closest(".article").attr("data-article-id");
            
            get_selected_item_counter_outer = get_selected_item_counter_outer + 1; 

          }
      });     
          
      $(".selected_locations_section .outer_selected_locations_block .selected_header_block .selected_location_counter").html("("+get_selected_item_counter_outer+")");
    
      if(get_selected_item_counter_outer > 0 ){
        	$(".selected_locations_section").addClass("panel_visible");
      }else{
        	$(".selected_locations_section").removeClass("panel_visible");
      }    
    
    
  });    
   
  
  $('body').on('click', '.top_bar_filter_selected_option_section .f_search_clear_all', function() {
      showResultsAll();        	
      //$(".inner_search_box #restaurant_search-box").val('');  
      $(".inner_search_box #zip_code_search-box").val('');  
      //$(".inner_search_box #cuisine_search-box").val('');  
      //$(".inner_search_box #space_search-box").val('');  
      $(".inner_search_box #guests_search-box").val('');     
  });    
  

  $("body").on('keyup change', '.inner_search_box input[type="search"]', function (e) {
      var get_search_input_obj = $(this);
      if(get_search_input_obj.length < 1){
        	get_search_input_obj.closest(".inner_search_box_section").addClass("active_error_block");       
      }else{
        	get_search_input_obj.closest(".inner_search_box_section").removeClass("active_error_block");       
      }        
  });  
  
  $("body").on('change', '.inner_check_box_section .inner_search_box input[type="checkbox"]', function (e) {
      var get_search_input_obj = $(this).closest(".inner_search_box");
      var get_check_count = 0;
      var blog_filter_pathname = "";
      get_search_input_obj.find(".form-checkbox-group").each(function(){
        if($(this).find("input").is(':checked')){
          	get_check_count = get_check_count + 1;
          	var get_restaurant_count_name = $(this).find("input").attr("id");
          if(get_check_count == 1){
            	blog_filter_pathname = blog_filter_pathname + "?restaurant"+get_check_count+"="+get_restaurant_count_name;
          }else{
	            blog_filter_pathname = blog_filter_pathname + "&restaurant"+get_check_count+"="+get_restaurant_count_name;
          }
        }
      });    
    
     // alert(get_check_count);
      if($(this).closest(".inner_search_box_section").hasClass("restaurant_search_box")){
          //var blog_newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?restaurant=' + get_check_count;
          var blog_newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + blog_filter_pathname;
          window.history.replaceState({path: blog_newurl},'',blog_newurl);    
      }
    
      if(get_check_count >= 1){
        	get_search_input_obj.closest(".inner_check_box_section").addClass("active_checkbox_block");       
      }else{
        	get_search_input_obj.closest(".inner_check_box_section").removeClass("active_checkbox_block");       
      }        
      
  });    
  
  //$('#checkbox').is(':checked'); 
  
  $('body.template-blog.pg__PrivateParties .inner_search_box input[type="search"]').on("focus", function() {
    $(this).closest(".inner_search_box_section").addClass('focus_active');
  }).on("blur", function() {
    $(this).closest(".inner_search_box_section").removeClass('focus_active');
  });
  

  if ($('.article_private_parties_img_with_text .slick-carousel').length){ 
      $('.article_private_parties_img_with_text .slick-carousel').slick({
        infinite: true,
        slidesToShow: 1, // Shows a three slides at a time
        slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
        arrows: false, // Adds arrows to sides of slider
        dots: true // Adds the dots on the bottom
      });
  }
    
    function GetParameterReDValues(param) {  
      var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');  
      for (var i = 0; i < url.length; i++) {  
        var urlparam = url[i].split('=');  
        if (urlparam[0] == param) {                    	                  	
          return urlparam[1];                   
        }  
      }  
    }  
  
    var blog_cat_filter_status = GetParameterReDValues('restaurant');
  
    function get_blog_cat_filter_query(){
        var url = document.location.href;
        var qs = url.substring(url.indexOf('?') + 1).split('&');
        for(var i = 0, result = {}; i < qs.length; i++){
            qs[i] = qs[i].split('=');
            result[qs[i][0]] = decodeURIComponent(qs[i][1]);
        }
        return result;
    }  

    var get_blog_cat_filter_query_result = get_blog_cat_filter_query();
  
    if (typeof get_blog_cat_filter_query_result === "undefined") {        
    }else{
      
		//alert(get_blog_cat_filter_query_result);      
      
        //console.log(get_blog_cat_filter_query_result);      
        $.each(get_blog_cat_filter_query_result,function(index,row) {                    
          //$(".upsell_pro_id_"+row.variant_id).addClass("addedThisProduct");    
          //console.log(index + "="+row);
          $(".restaurant_search_box .inner_search_box").find("label[for='" + row + "']").trigger("click");
        });        
      	
      
        setTimeout(function(){
          $(".restaurant_search_box button[type=submit]").trigger("click");
        }, 1000);
      	
    }
});

